import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    className: 'onboarding-step-1',

    use_case: '',

    use_cases: [
        'Capture better product feedback',
        'Survey users to understand their sentiments',
        'Improve my feature prioritization process',
        'Simplify how I manage all my feedback',
        'I\'m here for something else'
    ],

    events: {
        'keyup input[name="company"]'             : 'onChange',
        'click .use-case-options li'              : 'onSelectUseCase',
        'keydown textarea[name="usercase_other"]' : 'onUsercaseEnter',
        'submit form'                             : 'onSubmit'
    },

    dom_handlers: {
        onChange: function() {
            this.checkFormChange();
        },

        onSelectUseCase: function(e) {
            this.use_case = $(e.currentTarget).data('val');
            this.checkFormChange();

            var show = this.use_case === '';

            this.$el.find('textarea[name="usercase_other"]').toggle(show);

            if (show) {
                this.$el.find('textarea[name="usercase_other"]').focus();
            }
        },

        onUsercaseEnter: function(e) {
            this.use_case = Form.getData(this.$el.find('form'), 'usercase_other');
            this.checkFormChange();
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');
            this.$el.find('.submit-progress').addClass('active');

            Cache.app.request({
                action:  'account/completeSetup',
                data: {
                    company   : form_data.company,
                    use_case  : this.use_case
                },
                success: () => {
                    Cache.account.set({
                        company  : form_data.company,
                        use_case : this.use_case
                    });

                    setTimeout(() => {
                        this.$el.find('.submit-progress').text('Your account is set up.');

                        setTimeout(() => {
                            this.trigger('complete');
                        }, 500);
                    }, 2000);
                }
            });
        }
    },

    checkFormChange: function() {
        var form_data = Form.getData(this.$el.find('form'));

        this.$el.find('button:submit').prop('disabled', !this.use_case || !form_data.company);
    },

    render: function() {
        var use_case_options = '';
        var last_option = this.use_cases.pop();

        this.use_cases = Util.shuffleArray(this.use_cases);
        this.use_cases.push(last_option);

        this.use_cases.forEach((val, index) => {
            use_case_options += '<li data-val="' + (index === this.use_cases.length - 1 ? '' : val) + '"' + (val === this.use_case ? ' class="selected"' : '') + '>' + val + '</li>';
        });

        var content =
        '<h1 class="text-align-center"><b>Welcome to Userback</b></h1>' +
        '<p class="text-align-center margin-bottom-32">Let\'s quickly set you up</p>' +
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Company name</div>' +
                '<input class="solid medium" name="company" type="text" maxlength="100" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">What\'s your primary use case of Userback?</div>' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-left" data-update="true">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium">' +
                        '<span class="' + (this.user_case ? '' : ' placeholder-text') + '">' + (this.user_case || 'Select...') + '</span>' +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select large use-case-options">' + use_case_options + '</ul>' +
                    '</div>' +
                '</div>' +
                '<textarea name="usercase_other" class="solid compact margin-top-8" rows="4" maxlength="200" style="display:none;"></textarea>' +
            '</div>' +
            '<div class="onboarding-footer onboarding-footer-simple margin-top-32">' +
                '<button type="submit" class="primary medium fluid" disabled>Get Started</button>' +
                '<div class="submit-progress text-info margin-top-12">Setting up your account...</div>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        Form.setData(this.$el.find('form'), {
            company: Cache.account.get('company'),
            name: Cache.getRealUser().get('name'),
        });

        this.checkFormChange();

        return this;
    }
});